export const SSO_LOGIN_PENDING_KEY = 'sso_login_pending';
export const SSO_LOGIN_PENDING_VALUE = 'pending';
export const SSO_REDIRECT_DELAY_MS = 300;
